/**
 * API calls of the order diagnosis tab (SUPPORT-TOOLS item 1), on the shared ops client.
 *
 * The DTO types are re-exported from the generated client, never restated — see `support-api.ts`.
 */

import type {
  CannedResponseDto,
  OpsDiagnosisDto,
} from '../../../../libs/api-client/src/generated/models';
import { opsClient, shopGrant } from './ops-api';

export type {
  CannedResponseDto as CannedResponse,
  OpsDiagnosisActionDto as DiagnosisAction,
  OpsDiagnosisAttentionItemDto as DiagnosisAttentionItem,
  OpsDiagnosisCorrectionItemDto as DiagnosisCorrectionItem,
  OpsDiagnosisDocumentDto as DiagnosisDocument,
  OpsDiagnosisDto as Diagnosis,
  OpsDiagnosisFailedJobDto as DiagnosisFailedJob,
  OpsDiagnosisWebhookEventDto as DiagnosisWebhookEvent,
} from '../../../../libs/api-client/src/generated/models';

/**
 * Diagnoses one order of a shop, with the shop's access grant. The API writes the audit row.
 *
 * @param shopId - The shop.
 * @param order - What the operator typed: `#1234`, `1234`, an order id or a gid.
 */
export async function diagnoseOrder(
  shopId: string,
  order: string,
): Promise<OpsDiagnosisDto> {
  const { data } = await opsClient().diagnoseOpsOrder({
    shopId,
    order,
    xOpsShopAccess: shopGrant(shopId),
  });
  return data;
}

/**
 * The active canned responses. The tab picks the one whose `key` its merchant action names; the
 * list is small (tens of rows), so it is read whole rather than asked for by key.
 */
export async function fetchCannedResponses(): Promise<CannedResponseDto[]> {
  const { data } = await opsClient().listCannedResponses({});
  return data.data;
}
